import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import type { HotelData } from "@/features/hotels/types/types";

export interface HotelDataContextValue {
  data: HotelData | null;
  setData: Dispatch<SetStateAction<HotelData | null>>;
}

export const HotelDataContext = createContext<HotelDataContextValue | null>(
  null,
);

export const useHotelDataContext = () => {
  const context = useContext(HotelDataContext);
  if (!context) {
    throw new Error(
      "useHotelDataContext must be used within a HotelDataProvider",
    );
  }
  return context;
};
